module.exports = __webpack_public_path__ + "public/SiteIcons/verifiEditIcon.svg?5e7be2dd";